<template>
  <div id="app">
    <transition name="sidebar-in-out">
      <sidebar id="fif-sidebar" v-if="showSidebar"></sidebar>
    </transition>
    <div id="fif-content" :class="{'sidebar': showSidebar}">
      <transition name="slide-in-out">
        <router-view></router-view>
      </transition>
    </div>
    <div v-if="popover" class="intro-popover">
      <div class="popover-content">
        <a @click="popover = false" class="fa fa-close"></a>
        <div class="img-wrapper">
          <img src="./assets/fif-logo.png" />
        </div>
        <h4>Welcome to the Forests in Focus Prototype.</h4>

<p>Forests in Focus is a joint effort by GreenBlue's Forest Products Working Group and the American Forest Foundation. The goal of this Forests in Focus initiative is to bring together the full value chain from brand owners to family forest owners to pro-actively engage in achieving shared sustainability outcomes.</p>

<p>Please note, this Prototype has been developed for the sole purpose for exploring and discussing, at a conceptual level, strategies for bringing visibility and transparency to responsible forest management. This is not a working tool to be used in any capacity except to share feedback to GreenBlue and the American Forest Foundation.</p>

<hr/>
<strong>
  For more information, and to provide feedback,
  please email <a href="mailto:fif@greenblue.org">fif@greenblue.org</a>
</strong>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarNav from '@/components/SidebarNav';
import popover from 'vue-popover';

export default {
  components: {
     popover,
    'sidebar': SidebarNav
  },
  computed: {
    showSidebar () {
      return this.$route.name !== 'home'
    }
  },
  mounted () {
    $('.intro-popup').height($(window).height());
  },
  data () {
    return {
      popover: true
    }
  },
  name: 'app'
}
</script>

<style lang="scss">
@import './scss/global';

#fif-sidebar {
  width: $nav-width;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 9;
}
#fif-content {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transition: all $animation-speed;
  z-index: 1;
  overflow: auto;
  &.sidebar {
    width: calc(100% - #{$nav-width});
    left: $nav-width;
  }
}

@keyframes slide-in {
  from { left: 100%; }
  to { left: 0; }
}
@keyframes slide-out {
  from { left: 0; }
  to { left: -100%; }
}

@keyframes sidebar-in {
  from { left: -1 * $nav-width; }
  to { left: 0; }
}
@keyframes sidebar-out {
  from { left: 0; }
  to { left: -1 * $nav-width; }
}

.slide-in-out-enter-active {
  position: absolute;
  animation: slide-in $animation-speed;
  width: 100%;
}

.slide-in-out-leave-active {
  position: absolute;
  animation: slide-out $animation-speed;
  width: 100%;
}

.sidebar-in-out-enter-active {
  animation: sidebar-in $animation-speed;
}
.sidebar-in-out-leave-active {
  animation: sidebar-out $animation-speed;
}

.intro-popover {
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 2rem;
  position: fixed;
  height: 100%;
  width: 100%;
  overflow: scroll;

  .popover-content {
    max-width: 750px;
    margin: 0px auto;
    background-color: #FFF;
    padding: 2rem 4rem;
    color: #727270;
    position: relative;
    box-shadow: 0px 0px 2rem #000;

    @include breakpoint(medium up) {
      padding: 4rem 7rem;
    }

    h4 {
      font-family: 'rajdhanisemibold';
      font-size: 2rem;
      text-transform: uppercase;
      color: $primary-color;
      letter-spacing: 1px;
      font-weight: bold;
      margin-bottom: 2rem;
    }

    hr {
      max-width: 100px;
      margin-left: 0px;
      border-bottom: 2px solid #333;
    }

    .img-wrapper {
      text-align: center;
      margin-bottom: 3rem;
    }

    .fa-close {
      color: inherit;
      font-size: 2rem;
      position: absolute;
      right: 1rem;
      top: 1rem;
    }
  }
}


@font-face {
    font-family: 'rajdhanibold';
    src: url('assets/fonts/rajdhani-bold-webfont.woff2') format('woff2'),
         url('assets/fonts/rajdhani-bold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

}

@font-face {
    font-family: 'rajdhanilight';
    src: url('assets/fonts/rajdhani-light-webfont.woff2') format('woff2'),
         url('assets/fonts/rajdhani-light-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

}

@font-face {
    font-family: 'rajdhanimedium';
    src: url('assets/fonts/rajdhani-medium-webfont.woff2') format('woff2'),
         url('assets/fonts/rajdhani-medium-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

}

@font-face {
    font-family: 'rajdhaniregular';
    src: url('assets/fonts/rajdhani-regular-webfont.woff2') format('woff2'),
         url('assets/fonts/rajdhani-regular-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

}

@font-face {
    font-family: 'rajdhanisemibold';
    src: url('assets/fonts/rajdhani-semibold-webfont.woff2') format('woff2'),
         url('assets/fonts/rajdhani-semibold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

}

</style>



// WEBPACK FOOTER //
// App.vue?7cb0d313